import React from "react";
import { connect } from "react-redux";
import * as router from "react-router-redux";
import isNil from "lodash/isNil";

import * as session from "../modules/session/actions";
import * as tracker from "../modules/tracker/actions";
import * as AuthEvents from "../modules/tracker/event-names/authentication-events";

import AppHeader from "../components/AppHeader/AppHeader";

class AppHeaderContainer extends React.PureComponent {
    myAccountPath = "/my-account";

    constructor(props) {
        super(props);
        this.handleLogOutClick = this.handleLogOutClick.bind(this);
        this.handleMyAccountClick = this.handleMyAccountClick.bind(this);
    }

    handleMyAccountClick(event) {
        this.props.navigateTo(this.myAccountPath);
    }

    handleLogOutClick(event) {
        this.props.trackEvent(AuthEvents.DID_LOGOUT);
        this.props.logOut();
    }

    render() {
        const links = [];

        if (this.props.isAuthenticated) {
            links.push({
                icon: "list-ul",
                text: "My Tests",
                href: `/team/${this.props.team.id}/dashboard`
            });
        }

        const displayLinks = links.map(link => {
            if (isNil(link.selected)) {
                link.selected = link.href === this.props.pagePath;
            }
            return link;
        });

        if (document) {
            if (this.props.pageTitle.text) {
                document.title = `WEVO - ${this.props.pageTitle.text}`;
            } else {
                document.title = "WEVO";
            }
        }

        return (
            <AppHeader
                user={this.props.user}
                team={this.props.team}
                links={displayLinks}
                isShareLink={this.props.isShareLink}
                isAuthenticated={this.props.isAuthenticated}
                pageTitle={this.props.pageTitle.text}
                pageTitleIcon={
                    this.props.pageTitle.text && this.props.pageTitle.icon
                }
                myAccountSelected={this.props.pagePath === this.myAccountPath}
                onLogOutClick={this.handleLogOutClick}
                onMyAccountClick={this.handleMyAccountClick}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const pageTitle = state.title;

    const pagePath = state.router.location.pathname;

    const { userId, teamId, authRequired, isShareLink } = state.session;
    const isAuthenticated = !authRequired;

    const user = state.entities.users[userId];
    const team = state.entities.teams[teamId];

    return {
        pageTitle,
        pagePath,
        user,
        team,
        isShareLink,
        isAuthenticated
    };
}

function mapDispatchToProps(dispatch) {
    return {
        logOut: err => dispatch(session.resetAuthToken(err)),
        navigateTo: url => dispatch(router.push(url)),
        trackEvent: (name, properties) =>
            dispatch(tracker.trackEvent(name, properties))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppHeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/AppHeaderContainer.js